import { ConfirmationDialog } from 'legacy/lut/components/widgets/public/partner360/programsManagementAdmin/ConfirmationDialog'
import { useAppDispatch } from 'legacy/lut/hooks/useAppDispatch'
import { FC, useCallback } from 'react'
import { useSelector } from 'react-redux'

import { ModalDialog } from 'core-components/library/modalDialog'

import { selectContacts } from '../../selectors'
import { deleteContact } from '../../thunks/deleteContact'

import { IContactsDeleteConfirmProps } from './models/contactsDeleteConfirmProps'

export const ContactsDeleteConfirm: FC<IContactsDeleteConfirmProps> = ({
  showDialog,
  setShowDialog,
  item,
  setItem,
  triggerCompleteness,
}) => {
  const dispatch = useAppDispatch()
  const data = useSelector(selectContacts)

  const handleCloseModal = useCallback(() => {
    setShowDialog(false)
  }, [setShowDialog])

  if (!item) {
    return null
  }

  return (
    <ModalDialog
      show={showDialog}
      size="xs"
      content={ConfirmationDialog}
      contentProps={{
        text: `Please confirm that you want to delete '${item.FullName}'`,
        onClick: async (submit: boolean) => {
          handleCloseModal()
          if (submit) {
            await dispatch(deleteContact(item))

            if (data.length <= 1) {
              await triggerCompleteness()
            }
          }

          setItem(null)
        },
      }}
      onClose={handleCloseModal}
    />
  )
}
